module.exports = __webpack_public_path__ + "static/media/aboutUs.1502dcf5.jpg";